export const inputCharCount = () => {
  const getInputLimit = (input) => parseInt(input.dataset.wmCharCount);

  const createCounterMessage = (input) => {
    const limit = getInputLimit(input);
    const messageSpan = document.createElement("span");
    messageSpan.setAttribute("data-wm-char-count-message", "");
    messageSpan.innerHTML = limit;

    input.insertAdjacentHTML("afterend", messageSpan.outerHTML);
  };

  const updateCount = (event) => {
    const input = event.target;
    const message = input.nextSibling;

    const limit = getInputLimit(input);
    input.value = input.value.substring(0, limit);

    const chars = input.value.length;
    message.innerHTML = `${limit - chars}`;
  };

  const inputsWithCounter = [
    ...document.querySelectorAll("[data-wm-char-count]"),
  ];

  inputsWithCounter.forEach((input) => {
    createCounterMessage(input);

    input.addEventListener("keyup", updateCount);
    input.addEventListener("change", updateCount);
  });
};
